// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ViewStack = require("../../../../reason/common/ViewStack.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");

function GeocodingError(props) {
  return JsxRuntime.jsx(PropertyAddressValidationCallout.make, {
    heading: "We could not verify the address",
    children: JsxRuntime.jsx(ViewStack.make, {
      p: "sm",
      children: JsxRuntime.jsxs("div", {
        children: [
          props.reason === "OutsideChapterBoundaries" ? "The address you entered is not within the boundaries of your chapter." : "We were unable to locate the address. Please check the address you entered above.",
          JsxRuntime.jsx("br", {}),
          JsxRuntime.jsx("br", {}),
          "If you have any questions, just ask for help using our messenger in the lower-right corner"
        ]
      })
    }),
    icon: "Error"
  });
}

let make = GeocodingError;

exports.make = make;
/* ViewStack Not a pure module */
